import * as React from 'react'
import { Typography } from '@lacedltd/laced-components'
import { useLocale, useTranslation } from 'hooks'
import * as S from '../SiteSettings.styles'
import { SiteSettingsUpdate } from '../types'
import SiteSettingsForm from './SiteSettingsForm/SiteSettingsForm'

const SiteSettingsModal = ({
  updatePrompt,
  dialogControls,
  isLoading,
  updateSiteSettings
}: SiteSettingsModal) => {
  const { t } = useTranslation()
  const { location, locale, currency } = useLocale()

  return (
    <>
      <S.ModalHeading as="h4">
        {updatePrompt
          ? t(`react_components.site_settings.heading`)
          : t(`react_components.site_settings.customize_heading`)}
      </S.ModalHeading>

      <Typography.Text variant="body">
        {t(`react_components.site_settings.current_selection`, {
          language: t(`shared.locales.language.${locale}`),
          currency: t(`shared.locales.currency.${currency}`),
          location: location.name
        })}
      </Typography.Text>

      <SiteSettingsForm
        updateSiteSettings={updateSiteSettings}
        dialogControls={dialogControls}
        isLoading={isLoading}
      />
    </>
  )
}

export default SiteSettingsModal

interface SiteSettingsModal {
  updatePrompt: boolean
  dialogControls: {
    open: boolean
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
  }
  updateSiteSettings: SiteSettingsUpdate
  isLoading: boolean
}
